import { render, staticRenderFns } from "./ProductRent.vue?vue&type=template&id=79df0028&scoped=true"
import script from "./ProductRent.vue?vue&type=script&lang=js"
export * from "./ProductRent.vue?vue&type=script&lang=js"
import style0 from "./ProductRent.vue?vue&type=style&index=0&id=79df0028&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79df0028",
  null
  
)

export default component.exports